import styled from "styled-components";
import { motion } from "framer-motion";

export const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 350px;
  width: 350px;

  .popup-loading {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .loading-wrapper {
      margin-top: 3rem !important;
    }
  }

  @media (max-width: 500px) {
    min-width: 320px;
    width: 320px;
  }
`;

export const Head = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Titles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TitleTexts = styled.div`
  display: flex;
  align-items: flex-start;
  height: 30px;
  overflow: hidden;

  .main-text {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 30px;
    font-size: 20px;
    color: #404040;
    font-weight: bold;
  }

  .light-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-right: 10px;
    font-size: 12px;
    font-weight: 300;
    color: #a7a7be;

    span {
      display: flex;
      align-items: center;
      height: 30px;
    }
  }
`;

export const Steps = styled.div`
  display: flex;
`;

export const Step = styled.div`
  width: 100%;
  flex: 1;
  height: 4px;
  margin: 20px 0;
  background: ${props => (props.active ? "#7E77EB" : "#e6e9f7")};
  border-radius: 2px;
  transition: background 0.3s;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 300px;
`;

export const NextButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: white;
  border: none;
  background: ${props => (props.disabled ? "#ccc" : "#26CC83")};
  border-radius: 10px;
  margin: 20px 0;
  font-size: 14px;
  padding: 10px 0;
  cursor: ${props => (props.disabled ? "normal" : "pointer")};
  transition: background 0.2s;
  position: relative;
  z-index: 2;

  :hover {
    background: ${props => (props.disabled ? "#ccc" : "#21B775")};
  }

  :active {
    background: ${props => (props.disabled ? "#ccc" : "#1CA76A")};
  }

  svg {
    margin-right: 10px;
  }

  .spinner-border {
    margin-right: 10px;
  }
`;

export const Seperator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .line {
    border-top: 2px dashed #e3e8f7;
    width: 100%;
  }

  .text {
    color: #a7a7be;
    margin: 0 20px;
  }
`;

export const GoogleButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: #a7a7be;
  background: #fff;
  border: 1px solid #d2d2d2;
  border-radius: 12px;
  margin: 20px 0;
  font-size: 16px;
  font-weight: 400;
  padding: 10px 0;
  cursor: pointer;
  transition: all 0.2s;

  svg {
    margin-right: 10px;
    width: 16px;
    height: 16px;
  }

  :hover {
    filter: brightness(0.95);
  }

  ::disabled {
    filter: brightness(0.95);
    cursor: not-allowed;
  }
`;

export const ChangePage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .light-text {
    font-size: 14px;
    font-weight: 300;
    line-height: 24.61px;
    color: #a7a7be;
    margin-left: 5px;
  }

  .link-text {
    font-size: 15px;
    font-weight: 400;
    line-height: 26.37px;
    color: #6d65ec;
    cursor: pointer;
  }
`;

export const DomainTitle = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: #404040;
`;

export const DomainDesc = styled.div`
  font-size: 12px;
  font-weight: 300;
  color: #838396;
  margin-top: 5px;
  margin-bottom: 10px;
`;

export const SendAgain = styled.p`
  font-size: 15px;
  font-weight: 400;
  line-height: 26.37px;
  color: #6d65ec;
  text-align: center;
  margin-bottom: 6px;
  cursor: pointer;
`;

export const RemainingSendAgain = styled.p`
  font-size: 14px;
  font-weight: 300;
  line-height: 24.61px;
  color: #a7a7be;
  cursor: not-allowed;
  text-align: center;
  margin-bottom: 6px;

  span {
    color: #6d65ec;
    font-weight: 400;
  }
`;

export const EditWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 14px;
  font-weight: 200;
  line-height: 24.61px;
  color: #a7a7be;
  margin-bottom: 24px;
  cursor: pointer;
`;

export const LoginWithButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: #6D65EC;
  background: #F0F2FB;
  border-radius: 12px;
  margin: 20px 0;
  font-size: 16px;
  font-weight: 400;
  padding: 10px 0;
  cursor: pointer;
  transition: all 0.2s;

  svg {
    margin-right: 10px;
    width: 16px;
    height: 16px;
  }

  :hover {
    filter: brightness(0.95);
  }

  ::disabled {
    filter: brightness(0.95);
    cursor: not-allowed;
  }
`;